import { Component } from '@angular/core';
import {AdminLookupScreeningComponent} from "../screening/screening.component";

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.css']
})
export class AdminLookupMonitoringComponent {

}
